// Store
import { useProductData } from "@/zustand/productStore";
import { useCartStore } from "@/zustand/cartStore";
import { useTemplateStore } from "@/zustand/templateStore";

// Assets
import { CheckIcon } from "@/assets/Icons";

// Types
import type {
  ProductDataState,
  Product,
  CartStore,
  TemplateStore,
} from "@/types/types";

const ExtendedWarrantyCheckbox: React.FC = () => {
  const productData = useProductData() as ProductDataState & {
    formatted_string?: string | null;
    preselect_warranty?: boolean;
    warrantyTexts?: {
      tr_product_pack_warranty_box_title?: string;
    };
  };

  const { orderSummary } = useTemplateStore() as TemplateStore;

  const { selectedProduct, warrantyState, setWarrantyState } =
    useCartStore() as CartStore & {
      selectedProduct: Product | null;
      warrantyState: boolean;
      setWarrantyState: (val: boolean) => void;
    };

  const productPackWarrantyCheckboxTitle =
    productData?.warrantyTexts?.tr_product_pack_warranty_box_title;
  const checkoutWarrantyCheckboxTitle =
    orderSummary?.tr_warranty_checkbox_title;
  const warrantyLabelRendered =
    productPackWarrantyCheckboxTitle || checkoutWarrantyCheckboxTitle;

  const formattedAmount =
    productData?.formatted_string?.replace(
      /(0\.00|0,00|0)/,
      String(selectedProduct?.warranty_price ?? 0),
    ) ?? "";

  const warrantyLabel = warrantyLabelRendered?.replace(
    "###react_warrPrice###",
    formattedAmount,
  );

  const toggleWarrantyCheckbox = () => {
    setWarrantyState(!warrantyState);
  };

  return (
    <div className="mt-4 mb-4 flex items-center gap-2">
      {warrantyState !== undefined && (
        <label className="text-bg-gray font-roboto flex cursor-pointer items-center gap-2 text-sm">
          <input
            type="checkbox"
            checked={warrantyState}
            onChange={toggleWarrantyCheckbox}
            className="peer hidden"
          />
          <div className="border-cc-gray peer-checked:bg-cc-gray flex h-5 w-5 items-center justify-center rounded border transition-all duration-200 peer-checked:border-transparent">
            <CheckIcon />
          </div>
          <span>{warrantyLabel ?? "Yes, I Want The Extended Protection"}</span>
        </label>
      )}
    </div>
  );
};

export default ExtendedWarrantyCheckbox;
